import React from 'react';
import { Breadcrumb } from 'zui/Antd';
import styled from 'styled-components';
import { palette } from 'theme/MainTheme';

const AnrBreadcrumb = (props) => <Breadcrumb {...props} />;
const BreadCrumbItem = (props) => <Breadcrumb.Item {...props} />;

const Breadcrumbs = styled(AnrBreadcrumb)`
	color: ${palette('text', 3)};
	font-size: 13px;

	a {
		color: ${palette('text', 3)};
		font-size: 13px;
	}
	a:hover {
		color: ${palette('secondary', 0)} !important;
	}

	> span:last-child {
		font-weight: 600;
		color: ${palette('text', 1)};
	}
`;

const BreadCrumbWrapper = styled.div`
	height: 25px;
	margin: 10px 10px 0px 10px;
	padding-left: 10px;
`;

export default Breadcrumbs;
export { BreadCrumbItem, BreadCrumbWrapper };
